module.exports = __webpack_public_path__ + "img/BDB466_F3EDC3_E3DD9F_ECE3AA-256px.793a7bde.png";